import React, { useState, useEffect } from "react";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { ReactComponent as PlusIcon } from "../../img/plusicon.svg";

import { instance2 } from "../../utils/axiosInstance";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { EyeIcon } from '@heroicons/react/16/solid';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { ReactComponent as VerticalLine } from "../../img/verticalline.svg";
import { ReactComponent as MagnificationLogo } from "../../img/magnificationlensicon.svg";
import { ReactComponent as OfficeIcon } from "../../img/004-office.svg";
import { ReactComponent as WhatsappIcon } from "../../img/404-whatsapp.svg";
import { ReactComponent as UserIcon } from "../../img/114-user.svg";
import { ReactComponent as ArrowUpIcon } from "../../img/307-arrow-up.svg";
import { ReactComponent as ArrowDownIcon } from "../../img/311-arrow-down.svg";
import { ReactComponent as BackButton } from "../../img/bacbuttonicon.svg";

import { formatNumber } from "../../numberingformat"; // Ensure formatNumber works for formatting

import StarRating from "../dashboard.js/starrating.js";

export default function LihatPemasok(){

    const navigate = useNavigate();
  
  const parseApiNumber = (numStr) => {
    return parseFloat(numStr).toFixed(1); // returns "3.0" as a string but with a dot; you can then convert it to a number if needed.
  };  
  const localDateString = (thedate) =>{

    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
    const day = String(thedate.getDate()).padStart(2, '0');
    
  //console.log("startDate", thedate);
  const localDateString = `${year}-${month}-${day}`;
  
  return localDateString
  
  }
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id"); // Get the ID from URL
  const [loadingIngredients, setLoadingIngredients] = useState(true);
  const [errorIngredients, setErrorIngredients] = useState(null);
  const [dropdowns, setDropdowns] = useState([null]); // Store dropdowns with initial null value
  const [userId, setUserId] = useState("");
  const [ingredients, setIngredients] = useState([]);
    const [regencyId, setRegencyId] = useState([]);
    const [errorData, setErrorData] = useState(null);
    const [supplierData, setSupplierData] = useState([]);
    const [priceData, setPriceData] = useState([]);
        const [loadingData, setLoadingData] = useState(true);


        

  // Fetch regency data
  useEffect(() => {
    const fetchRegencyData = async () => {
      try {
        const response = await instance2.get("regency");
        setRegencyId(response.data); // Access the appropriate field in the response
      } catch (err) {
        setErrorData(err.message);
      } finally {
        setLoadingData(false);
      }
    };
  
    fetchRegencyData();
  }, []);
  

  useEffect(() => {
    setLoadingData(true); // Start the loading indicator
      const fetchSupplierData = async () => {
        try {
          // Fetch supplier data
          const supplierResponse = await instance2.get(`/supplier/${id}`);
          const supplierData = supplierResponse.data.map((data) => ({
            id: data.id,
            name: data.supplier_name,
            address: data.address,
            phone: data.phone,
            pic: data.pic,
          }));
        
          const localDateString = (thedate) =>{

            const year = thedate.getFullYear();
            const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
            const day = String(thedate.getDate()).padStart(2, '0');
            
          //console.log("startDate", thedate);
          const localDateString = `${year}-${month}-${day}`;
          
          return localDateString
          
          }
          //console.log("supplier data", supplierData[0].id);
          // Fetch supplier rate data based on the supplier id
          const supplierRateResponse = await instance2.get(`/supplier_rate/${id}/2023-01-01/${localDateString(new Date())}`);
          const supplierRateData = supplierRateResponse.data;
          
          //console.log("supplier rate", supplierRateData);
        
          // Combine the data from both APIs
          const combinedData = {
            ...supplierData[0], // Assuming you want to take the first supplier's data
            
            rate_qty: supplierRateData.length>0 ? Number(parseApiNumber(supplierRateData[0].rate_qty)) : 0, // Add supplier rate if available
            rate_quality: supplierRateData.length>0 ? Number(parseApiNumber(supplierRateData[0].rate_quality)) : 0, // Add supplier rate if available
            rate_time: supplierRateData.length>0 ? Number(parseApiNumber(supplierRateData[0].rate_time)) : 0, // Add supplier rate if available
            order_count: supplierRateData.length>0 ? Number(parseApiNumber(supplierRateData[0].order_count)) : 0, // Add supplier rate if available
            order_value: supplierRateData.length>0 ? Number(parseApiNumber(supplierRateData[0].ingredient_price)) : 0, // Add supplier rate if available
          };
        
          //console.log("combined data", combinedData);
        
          // Update state with the combined data
          setSupplierData(combinedData);
        } catch (err) {
          console.error("Error fetching data:", err);
          setErrorData("Failed to fetch supplier data or supplier rates"); // Handle errors
        } finally {
          setLoadingIngredients(false); // Stop loading indicator
        }
        
      };
      setLoadingData(false); // Start the loading indicator
    
      fetchSupplierData();
    }, []);


    useEffect(() => {
      const fetchPriceData = async () => {
        try {
          const response = await instance2.get(`price/supplier/${id}`);
          setPriceData(response.data); // Access the appropriate field in the response
        } catch (err) {
          setErrorData(err.message);
        } finally {
          setLoadingData(false);
        }
      };
    
      fetchPriceData();
      
      //console.log("price",priceData)
    }, []);
    
    
 useEffect(() => {
  setLoadingData(true); // Start the loading indicator
    const fetchIngredients = async () => {
      try {
        const response = await instance2.get("ingredient_category_master"); // Use instance2 for API call
        const ingredientsData = response.data.map((ingredient) => ({
          id: ingredient.id,
          name: ingredient.name,
        }));
  
        setIngredients(ingredientsData); // Update state with formatted data
      } catch (err) {
        setErrorIngredients("Failed to fetch ingredient categories"); // Handle errors
      } finally {
        setLoadingIngredients(false); // Stop loading indicator
      }
    };
    setLoadingData(false); // Start the loading indicator
  
    fetchIngredients();
  }, []);
  
    useEffect(() => {
      const storedUserId = localStorage.getItem("userId");
      if (storedUserId) {
        setUserId(parseInt(storedUserId, 10)); // Ensure userId is an integer
        setFormData((prev) => ({
          ...prev,
          admin_id: parseInt(storedUserId, 10), // Automatically update admin_id
        }));
      }
    }, []);
  
    
  const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        })); 
      };

 const [formData, setFormData] = useState({
    name: "",
    regency_id: "",
    address: "",
    pic: "",
    phone: "",
    email: "",
    description: "",
    admin_id: userId,
    category_count: 0, // Initial category count
    categories: [], // Array to store selected categories
  }); 

  const isFormValid = () => {
    return (
      formData.name &&
      formData.pic &&
      formData.phone &&
      formData.email &&
      formData.address &&
      formData.regency_id &&
      dropdowns.length > 0 &&
      dropdowns.every((dropdown) => dropdown !== "")
    );
  };
 const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
  
    try {
      const response = await instance2.post("supplier_category", formData);
  
      //console.log("Success:", response.data);
  
      // Refresh the page after successful submission
  window.history.back(); // Goes to the previous page
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const updateCategories = (dropdownValues) => {
    const categories = dropdownValues.filter((value) => value !== null); // Exclude null values
    setFormData((prev) => ({
      ...prev,
      categories, // Directly store the selected category.id values
    }));
  };
  

  const updateCategoryCount = (dropdownValues) => {
    const count = dropdownValues.filter((value) => value !== null).length; // Count non-null values
    setFormData((prev) => ({
      ...prev,
      category_count: count, // Update category_count accurately
    }));
  };
  

   // Add a new dropdown
   const handleAddDropdown = () => {
    const newDropdowns = [...dropdowns, null]; // Add a new empty dropdown
    setDropdowns(newDropdowns);
    updateCategories(newDropdowns);
    updateCategoryCount(newDropdowns);
  };

  const handleDropdownChange = (value, index) => {
    const updatedDropdowns = [...dropdowns];
    updatedDropdowns[index] = value; // Update the selected value for the current dropdown
    setDropdowns(updatedDropdowns); // Update state
    updateCategories(updatedDropdowns);
    updateCategoryCount(updatedDropdowns);
  };
  const filteredIngredients = (index) => {
    const selectedIds = new Set(dropdowns.filter((item, i) => item !== null && i !== index));
    return ingredients.filter((ingredient) => !selectedIds.has(ingredient.id));
  };

// Handle dropdown deletion
const handleDeleteDropdown = (index) => {
    const newDropdowns = dropdowns.filter((_, i) => i !== index); // Remove the dropdown at the specified index
    setDropdowns(newDropdowns);
    updateCategories(newDropdowns);
    updateCategoryCount(newDropdowns);
  };

      const [searchQuery, setSearchQuery] = useState(""); // State for search input
  
    const filteredData = priceData.filter((item) => {
      const searchValue = searchQuery.toLowerCase();
  
      return (
        (item.ingredient_name?.toLowerCase().includes(searchValue) || false) ||
        (item.supplier_name?.toLowerCase().includes(searchValue) || false) ||
        (item.phone?.toLowerCase().includes(searchValue) || false) 
      );
    });
  
      const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 5;
    
      const totalPages = Math.ceil(filteredData.length / itemsPerPage);
      const paginatedData = filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );
    
      const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
      };
    
      const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
      };
    
      // Determine which page numbers to show
      let pageNumbers = [];
      const maxVisiblePages = 5;
    
      if (totalPages <= maxVisiblePages) {
        pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
      } else {
        if (currentPage <= 3) {
          // Near the beginning
          pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
        } else if (currentPage >= totalPages - 2) {
          // Near the end
          pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        } else {
          // In the middle
          pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
        }
      }



    return(
        <div className="p-4">
            
            <div className="flex flex-row gap-4 items-center">
                                  <div className="bg-white p-2 rounded-full cursor-pointer"
                                      onClick={() => window.history.back()}>
                                  <BackButton 
                                  className="rotate-180 text-black" />
                                  </div>
                <h1 className="block text-black text-xl sm:text-2xl my-2 font-medium">Informasi Pemasok</h1>
                </div>
  
  {loadingData &&  <li className="px-4 py-8 flex justify-center">
                {/* Loading Spinner */}
                <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
              </li>}

  {/* Form Section */}
  <div className="py-5">
  <div className="flex flex-col gap-4 lg:flex-row justify-between items-center bg-gray-200 p-3 rounded-[25px]">
    {/* Left Column */}
    <div className="flex flex-col gap-1 px-4 w-full">
    <div className="flex flex-col sm:flex-row gap-4 text-xl bold font-bold">
      {supplierData.name}       
      </div>
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <OfficeIcon/>
      {supplierData.address}       
      </div>
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <WhatsappIcon/>
      {supplierData.phone}       
      </div>
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <UserIcon/>
      {supplierData.pic}       
      </div>
      
    </div>

    {/* Center Column */}
    <div className="flex flex-col sm:flex-row w-full items-center text-center ">
      <div>
      <div className="flex flex-row gap-2 items-center text-center w-full">
       <div className="text-center items-center bg-white p-2 rounded-[15px]">
        <div>Kualitas</div>
        <div>{supplierData.rate_quality}</div>
        <div>
            <StarRating
             rating={supplierData.rate_quality != null ? Number(parseApiNumber(supplierData.rate_quality)) : 0}
             maxStars={1}
            />   
        </div>
       </div>

       <div className="text-center items-center bg-white p-2 rounded-[15px]">
        <div>Kuantitas</div>
        <div>{supplierData.rate_qty}</div>
        <div>
            <StarRating
             rating={supplierData.rate_qty != null ? Number(parseApiNumber(supplierData.rate_qty)) : 0}
             maxStars={1}
            />   
        </div>
       </div>

       <div className="text-center items-center bg-white p-2 rounded-[15px]">
        <div>Waktu</div>
        <div>{supplierData.rate_time}</div>
        <div>
            <StarRating
             rating={supplierData.rate_time != null ? Number(parseApiNumber(supplierData.rate_time)) : 0}
             maxStars={1}
            />   
        </div>
       </div>

      </div>
      </div>
      
      
    </div>

    {/* Right Column */}
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-row gap-4 items-center">
<div className="flex flex-col items-center text-center bg-white p-2 rounded-[15px] w-1/2 min-h-[100px]">

        <div>Performa</div>
        <div>{(supplierData.rate_time + supplierData.rate_qty + supplierData.rate_quality)/3 !== 0 ? 
        ((supplierData.rate_time + supplierData.rate_qty + supplierData.rate_quality)/3).toFixed(1) : 0}</div>
        <div>
            <StarRating
             rating={(supplierData.rate_time + supplierData.rate_qty + supplierData.rate_quality)/3 != null ? 
              Number(parseApiNumber((supplierData.rate_time + supplierData.rate_qty + supplierData.rate_quality)/3)) : 0}
             maxStars={1}
            />   
        </div>

       </div>

       <div className="flex flex-col items-center text-center bg-white p-2 rounded-[15px] w-1/2 min-h-[100px] gap-4">

        <div>Jumlah PO</div>
        <div>{supplierData.order_count}
        </div>
        
       </div><div className="flex flex-col items-center text-center bg-white p-2 rounded-[15px] w-1/2 min-h-[100px] gap-4">

        <div>Nilai PO</div>
        <div>Rp. {formatNumber(supplierData.order_value)},00
        </div>
        
       </div>
       
       </div>
    </div>

  </div>


  {/* <div className="w-full flex flex-col sm:flex-row justify-center mt-4 px-4 sm:px-8 gap-5">
    <button
      // onClick={handleSubmit}
      //     disabled={!isFormValid()}
          className={`py-5 px-8 rounded-[30px] text-sm transition-colors duration-300 bg-merah-no text-white hover:bg-merah-hover"
           }`}
    >
      Upload Harga
    </button>
  </div> */}
  </div>
        
    <div className="p-2">

{/* Table Section */}
  
  <div className="flex flex-row items-center justify-between mb-4">
      <h2 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Harga</h2>
      <button
        type="button"
        onClick={() => navigate(`/uploadharga?id=${id}`)}
        className="rounded-[25px] p-2 px-8 bg-merah-no hover:bg-merah-hover text-white"
      >
        Upload Harga
      </button>
    </div>
  {loadingData && <p>Loading...</p>}
  {errorData && <p className="text-red-500">{errorData}</p>}
  {!loadingData && priceData.length === 0 && <p>No data available</p>}
  {!loadingData && priceData.length > 0 && (
    <>  
    {/* Search Bar */}
          <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2 w-full md:w-auto">
            <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center w-full md:w-auto justify-start">
              <MagnificationLogo />
              <VerticalLine className="mx-1" />
              <input
                type="text"
                placeholder="Telusuri data berdasarkan kategori, bahan baku, atau deskripsi"
                className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm"
                style={{
                  width: `${"Telusuri data berdasarkan kategori, bahan baku, atau deskripsi".length}ch`,
                }}
                value={searchQuery} // Controlled input
                onChange={(e) => setSearchQuery(e.target.value)} // Update search query
              />
            </div>
          </div>
      <table className="w-full border-gray-300">
        <thead>
          <tr
          className="bg-white">
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2 rounded-tl-[15px] text-center">
              No
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left">
              Nama Bahan
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left">
              Harga
            </th>
            {/* <th className="border-b border-gray-300 px-2 sm:px-4 py-2">
              Kategori Utama
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2">
              Alamat
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2">
              Narahubung
            </th> */}
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left">
              Update Terakhir
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left">
              Hari Sejak Update Terakhir
            </th>
            <th className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left rounded-tr-[15px]">
              Selisih dengan Harga Sebelumnya
            </th>
            {/* <th className="border-b border-gray-300 px-2 sm:px-4 py-2">
              Deskripsi
            </th> */}
                {/* <th
                  className="border-b border-gray-300 px-2 sm:px-4 py-2 rounded-tr-[15px] text-center"
                >
                  Aksi
                </th> */}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={item.ingredient_id} className={`hover:bg-gray-200 ${
              index % 2 === 0 ? "bg-transparent" : "bg-gray-50"
            }`}>
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2 text-center">
              {index + 1 + (currentPage - 1) * itemsPerPage}
              </td>
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left">
                {item.ingredient_name}
              </td>
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left">
                {formatNumber(item.price)}
              </td>
              {/* <td className="border-b border-gray-300 px-2 sm:px-4 py-2">
                {item.category_name || "-"}
              </td>
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2">
                {item.address}
              </td>
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2">
                {item.pic}
              </td> */}
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left">
                {localDateString(new Date(item.createdat))}
              </td>
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2 text-center">
                {(item.day_diff)}
              </td>
              
              <td className="border-b border-gray-300 px-2 sm:px-4 py-2 justify-center text-center items-center">
                <div className={`flex row justify-center text-center items-center gap-4 ${item.price_diff> 0 ? "text-red-500" : "text-green-500"} `}>
                {item.price_diff< 0 ? <ArrowDownIcon className="text-green-500"/> : item.price_diff > 0 ? <ArrowUpIcon className="text-red-500"/> : ""}
                {formatNumber(item.price_diff)}</div>
              </td>
              {/* <td className="border-b border-gray-300 px-2 sm:px-4 py-2">
                {item.description}
              </td> */}
                                {/* <td className="border-b px-4 py-2 text-center">
                                <button
                                    className="text-gray-500 p-2 rounded hover:text-green-500"
                                    // onClick={() => handleEdit(item)}
                                  >
                                    <EditIcon className="w-5 h-5" 
                        onClick={() => navigate(`/editpemasok?id=${item.id}`)}/>
                                  </button>

                                  <button
                                    className="text-gray-500 p-2 rounded hover:text-green-500"
                                    // onClick={() => handleEdit(item)}
                                  >
                                    <EyeIcon className="w-5 h-5" 
                        onClick={() => navigate(`/lihatpemasok?id=${item.id}`)}/>
                                  </button>
                                </td> */}
            </tr>
          ))}
        </tbody>
      </table>

    {/* Pagination Controls */}
    <div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
    </>
  )}
</div>
</div>
    )
}